<script setup lang="ts">
import { onMounted, ref } from 'vue'

const videoPlayer = ref<HTMLVideoElement | null>(null)

onMounted(() => {
  if (videoPlayer.value) {
    videoPlayer.value.addEventListener('play', () => {
      if (videoPlayer.value)
        videoPlayer.value.controls = true
    })

    videoPlayer.value.addEventListener('pause', () => {
      if (videoPlayer.value)
        videoPlayer.value.controls = false
    })
  }
})
</script>

<template>
  <section flex items-center justify-center pl-3px pr-3px>
    <iframe
      flex
      class="video"
      src="https://www.youtube.com/embed/W1FG4K-2Rn8"
      allowfullscreen
      frameborder="0"
      aspect-ratio-video
      w="640px <md:full"
      rounded-4
      cursor-pointer
    />
  </section>
</template>

<style scoped>
.video {
  object-fit: cover;
}
</style>
